import { fetchApi, catchFetchApiError, getFetchApiJSONResponse, getUserId } from 'shared/functions';
import { portfolioTypes } from 'shared/constants/portfolioTypes';

/**
 * TODO [ZSz]: rename to uploadPortfolio
 */
export const uploadPortfolioUnified = async ({ portfolio, uploadEntities, portfolioId }) => {
  const formData = new FormData();
  formData.append('file', portfolio, portfolio.name);
  formData.append('uploadEntities', uploadEntities);

  const params = {
    method: 'POST',
    body: formData,
  };

  const url = `/user-profile/portfolios/upload-portfolio/${portfolioId}`;

  return fetchApi(url, params, ['Content-Type'])
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

/**
 * TODO [ZSz]: Code below should be removed after successfull implementation of unified portfolio upload
 */

const getUploadUrlByPortfolioType = (type, userId) => {
  switch (type) {
    case portfolioTypes.CREDIT_RATING:
    default:
      return `/storefront/users/${userId}/isin_upload`;
    case portfolioTypes.CREDIT_REVIEW:
      return `/sig/api/storefront/users/${userId}/add-portfolio-to-dossier/`;
    case portfolioTypes.ESG_ANALYSIS:
      return `/esg/api/upload-portfolio/`;
  }
};

export const uploadPortfolio = async ({
  portfolio,
  organisationId,
  type = portfolioTypes.CREDIT_RATING,
}) => {
  const userId = getUserId();

  const formData = new FormData();
  formData.append('file', portfolio, portfolio.name);

  if (type === portfolioTypes.CREDIT_REVIEW) {
    formData.append('organisationId', organisationId);
  }

  const params = {
    method: 'POST',
    body: formData,
  };

  const url = getUploadUrlByPortfolioType(type, userId);

  return fetchApi(url, params, ['Content-Type'])
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const confirmPortfolio = async dossierId => {
  const userId = getUserId();
  const confirmPortfolioUrl = `/sig/api/storefront/users/${userId}/confirm-portfolio/${dossierId}`;

  const params = { method: 'POST' };

  return fetchApi(confirmPortfolioUrl, params)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const confirmPortfolioESG = async confirmationData => {
  const confirmPortfolioUrl = `/esg/api/update-portfolio/`;

  const params = {
    method: 'PUT',
    body: JSON.stringify(confirmationData),
  };

  return fetchApi(confirmPortfolioUrl, params)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};
